import { render } from "./side-nav.vue?vue&type=template&id=11480a39"
import script from "./side-nav.vue?vue&type=script&lang=js"
export * from "./side-nav.vue?vue&type=script&lang=js"

import "./side-nav.vue?vue&type=style&index=0&id=11480a39&lang=scss"
script.render = render

export default script